import * as Models from "../../ts/rlAdmin.models";
import * as Utils from "../../ts/rlAdmin.utils";
import * as Consts from "../../ts/rlAdmin.consts";
import { NotifyService } from "../../services/notify-service";
import { AclService } from "../../services/acl-service";
import { SecurityConfigService } from "../../services/security-config-service";

export class EditPolicyPermissionsController {
    static $inject = ["$scope", "$q", "$window", "securityConfigService", "notifyService", "aclService"];

    treeNodes: Models.ISecurityTreeNode[];
    treeRows: Models.ISecurityTreeRow[];
    visibleTreeRows: Models.ISecurityTreeRow[];
    treeNodeChildMap: { [nodeID: string]: string[] };
    //treeNodeParentMap: { [nodeID: string]: string; }

    securityRights: Models.ISecurityRight[];

    securityPolicyID: string;
    securityPolicy: Models.IAspNetSecurityPolicy;
    policyPermissions: Models.IAspNetSecurityPolicyPermission[];
    policyType: number;

    showEffective: boolean;
    isAdmin: boolean;
    acls: string[];

    returnUrl: string;

    _permissionUpdatedCallbacks: _.Dictionary<() => void> = {};

    constructor(private $scope: ng.IScope, private $q: ng.IQService, private $window: ng.IWindowService, private securityConfigService: SecurityConfigService, private notifyService: NotifyService, private aclService: AclService) {

        this.treeNodes = [];
        this.treeRows = [];
        this.visibleTreeRows = [];
        this.showEffective = true;
        this.treeNodeChildMap = {};
        this.securityPolicyID = "";
        this.policyPermissions = [];
        this.policyType = null;
        this.isAdmin = false;
        this.acls = [];
        this.returnUrl = "";

        this.securityRights = [
            {
                name: "Read",
                rightFlag: Consts.AccessRight.Read
            },
            {
                name: "Write",
                rightFlag: Consts.AccessRight.Write
            },
            {
                name: "Create",
                rightFlag: Consts.AccessRight.Create
            },
            {
                name: "Delete",
                rightFlag: Consts.AccessRight.Delete
            },
            {
                name: "Admin",
                rightFlag: Consts.AccessRight.Admin
            }
        ];

        //var treeOpenWatch = () => {
        //    return this.treeRows.map((treeRow) => treeRow.open);
        //};
        //$scope.$watch(treeOpenWatch, (newValue, oldValue) => {

        //}, true);


    }


    RegisterPermissionChangedCallback(key: string, callback: () => void) {
        this._permissionUpdatedCallbacks[key] = callback;
    }

    RemovePermissionChangedCallback(key: string) {
        delete this._permissionUpdatedCallbacks[key];
    }

    OnPermissionChanged(rowKeys: string[]) {
        var callbacks = rowKeys.filter(rowkey => this._permissionUpdatedCallbacks[rowkey] != null).map(rowKey => this._permissionUpdatedCallbacks[rowKey]);
        callbacks.forEach(c => c());
    }

    CalculateVisibleRows() {
        this.visibleTreeRows = _.filter(this.treeRows, (treeRow) => {
            var open = true;
            var parent = treeRow.parentTreeRow;
            while (parent != null) {
                if (!parent.open) {
                    open = false;
                    break;
                }
                parent = parent.parentTreeRow;
            }
            return open;
        });
    }

    ConvertNodesToRows(parentRow: Models.ISecurityTreeRow, nodes: Models.ISecurityTreeNode[], level: number = 0) {
        var output: Models.ISecurityTreeRow[] = [];
        _.forEach(nodes, (node) => {
            var rowKey = node.key;

            if (parentRow != null) {
                rowKey = parentRow.rowKey + "|" + rowKey;
            }

            var treeRow: Models.ISecurityTreeRow = {
                rowKey: rowKey,
                level: level,
                node: node,
                open: level == 0,
                parentTreeRow: parentRow,
                childTreeRows: []
            };

            var open = false;
            _.foreachGraph(node.childNodes, (n) => n.childNodes, (n) => {
                switch (this.policyType) {
                    case Consts.SecurityPolicyType.Activity:
                        if (_.any(this.policyPermissions, (p) => this.MatchActivityPermission(p, n))) {
                            open = true;
                        }
                        break;
                    case Consts.SecurityPolicyType.Data:
                        if (_.any(this.policyPermissions, (p) => this.MatchDataPermission(p, n))) {
                            open = true;
                        }
                        break;
                    default:
                        break;
                }
            });

            if (open) {
                treeRow.open = true;
            }

            // decide whether to hide tree branch from non super-admins
            var uri = "acl://activity/" + rowKey.replace(/\|/g, "/");
            var result = Utils.AclUtil.getAccessResult(this.acls, uri, Consts.AccessRight.Restrict);
            if (result != Consts.AccessResult.Deny || this.isAdmin) {
                output.push(treeRow);
                var childRows = this.ConvertNodesToRows(treeRow, node.childNodes, level + 1);
                treeRow.childTreeRows = childRows;
                _.forEach(childRows, (row) => output.push(row));
            }

        });
        return output;
    }

    MatchDataPermission(left: { charTypeID?: number, templateGroupID?: number, templateID?: number, charGroupID?: number, charID?: number }, right: { charTypeID?: number, templateGroupID?: number, templateID?: number, charGroupID?: number, charID?: number }) {
        return left.charTypeID == right.charTypeID &&
            left.templateGroupID == right.templateGroupID &&
            left.templateID == right.templateID &&
            left.charGroupID == right.charGroupID &&
            left.charID == right.charID;
    }

    MatchActivityPermission(left: { securityActivityID?: string }, right: { securityActivityID?: string }) {
        return left.securityActivityID == right.securityActivityID;
    }

    Init(securityPolicyID: string, policyType: number, returnUrl: string) {
        this.securityPolicyID = securityPolicyID;
        this.policyType = policyType;
        this.returnUrl = returnUrl;
        this.notifyService.startProgress();

        var promise1 = this.securityConfigService.getPolicyTree(this.policyType)
            .then((results) => {
                this.treeNodes = results;


                if (this.policyType == Consts.SecurityPolicyType.Activity) {
                    var mapTreeNodes = (n: Models.ISecurityTreeNode) => {
                        var children = [];
                        n.childNodes.forEach((cn) => {
                            children.push(cn.securityActivityID);
                            var childChildIDs = mapTreeNodes(cn);
                            children = children.concat(childChildIDs);
                        });
                        this.treeNodeChildMap[n.securityActivityID] = children;
                        return children;
                    };
                    this.treeNodes.forEach((n) => mapTreeNodes(n));
                }
            });

        var promise2 = this.securityConfigService.getPolicyPermissions(securityPolicyID)
            .then((results) => {
                this.policyPermissions = results;
            });

        var promise3 = this.securityConfigService.getSecurityPolicy(securityPolicyID)
            .then((result) => {
                this.securityPolicy = result;
            });

        var promise4 = this.aclService.loadAcls().then((acls) => {
            this.acls = acls;
            this.isAdmin = Utils.AclUtil.hasReadAccess(acls, Consts.Acl.Activities.Admin);
        });

        var promise5 = this.$q.all([promise3, promise4])
            .then(() => {
                if (this.isAdmin && this.securityPolicy.isGlobal) {
                    this.securityRights.push({
                        name: "Restrict",
                        rightFlag: Consts.AccessRight.Restrict
                    });
                }

                if (this.securityPolicy.policyType == Consts.SecurityPolicyType.Data) {
                    _.remove(this.securityRights, r => r.name == "Admin");
                }
            });

        var promise6 = this.$q.all([promise1, promise2])
            .then(() => {

                // filter out non-existing permissions
                this.policyPermissions = this.policyPermissions.filter((p) => {
                    var match = false;
                    _.foreachGraph(this.treeNodes, (n) => n.childNodes, (n) => {
                        switch (this.policyType) {
                            case Consts.SecurityPolicyType.Activity:
                               //remove filter on activity policy or else Ux2 permissions are removed when saving
                                    match = true;
                                break;
                            case Consts.SecurityPolicyType.Data:
                                if (this.MatchDataPermission(n, p)) {
                                    match = true;
                                }
                                break;
                            default:
                                break;
                        }
                    });
                    return match;
                });

                this.treeRows = this.ConvertNodesToRows(null, this.treeNodes);
            });

        this.$q.all([promise6, promise5])
            .finally(() => {
                this.OnPermissionChanged(this.visibleTreeRows.map(treeRow => treeRow.rowKey));
                this.CalculateVisibleRows();
                this.notifyService.endProgress();
            });
    }

    Toggle(treeRow: Models.ISecurityTreeRow, rightFlag: number) {
        var permission = this.FindPermission(treeRow) || this.CreatePermission(treeRow);
        var currentRightStatus = Utils.SecurityUtil.GetRightStatus(permission.permissionValue, rightFlag);
        var newStatus = 0;
        if (currentRightStatus == 0) {
            // currently nuetral, set to allow
            newStatus = 1;
        } else if (currentRightStatus == 1) {
            // currently allow, set to deny
            newStatus = -1;
        } else if (currentRightStatus == -1) {
            // currently deny, set to nuetral
            newStatus = 0;
        }
        permission.permissionValue = Utils.SecurityUtil.SetRightStatus(permission.permissionValue, rightFlag, newStatus);

        if (permission.permissionValue === 0) {
            this.RemovePermission(permission);
        }

        var affectedKeys: string[] = this.GetSelfAndParentAndChildRowKeys(treeRow);
        this.OnPermissionChanged(affectedKeys);
    }

    GetSelfAndParentAndChildRowKeys(treeRow: Models.ISecurityTreeRow) {
        var output: string[] = [];
        var context = treeRow;
        output.push(context.rowKey);
        while (context.parentTreeRow != null) {
            context = context.parentTreeRow;
            output.push(context.rowKey);
        }
        output.push(...this.GetChildRowKeys(treeRow));
        return output;
    }

    GetChildRowKeys(treeRow: Models.ISecurityTreeRow) {
        var output: string[] = treeRow.childTreeRows.map(t => t.rowKey);
        treeRow.childTreeRows.forEach(c => output.push(...this.GetChildRowKeys(c)));
        return output;
    }

    FindPermission(treeRow: Models.ISecurityTreeRow) {
        var output: Models.IAspNetSecurityPolicyPermission = null;
        switch (this.policyType) {
            case Consts.SecurityPolicyType.Activity:
                output = _.find(this.policyPermissions, (p) => this.MatchActivityPermission(p, treeRow.node));
                break;
            case Consts.SecurityPolicyType.Data:
                output = _.find(this.policyPermissions, (p) => this.MatchDataPermission(p, treeRow.node));
                break;
            default:
                break;
        }
        return output;
    }

    CreatePermission(treeRow: Models.ISecurityTreeRow): Models.IAspNetSecurityPolicyPermission {
        var permission: Models.IAspNetSecurityPolicyPermission = null;
        switch (this.policyType) {
            case Consts.SecurityPolicyType.Activity:
                permission = { permissionValue: 0, securityActivityID: treeRow.node.securityActivityID, securityPolicyID: this.securityPolicyID, securityPolicyPermissionID: null };
                this.policyPermissions.push(permission);
                break;
            case Consts.SecurityPolicyType.Data:
                permission = { permissionValue: 0, charTypeID: treeRow.node.charTypeID, templateGroupID: treeRow.node.templateGroupID, templateID: treeRow.node.templateID, charGroupID: treeRow.node.charGroupID, charID: treeRow.node.charID, securityPolicyID: this.securityPolicyID, securityPolicyPermissionID: null }
                this.policyPermissions.push(permission);
                break;
            default:
                break;
        }
        return permission;
    }

    RemovePermission(permission: Models.IAspNetSecurityPolicyPermission) {
        _.remove(this.policyPermissions, p => this.MatchPermissions(p, permission));
    }

    MatchPermissions(p1: Models.IAspNetSecurityPolicyPermission | Models.ISecurityTreeNode, p2: Models.IAspNetSecurityPolicyPermission | Models.ISecurityTreeNode) {
        switch (this.policyType) {
            case Consts.SecurityPolicyType.Activity:
                return this.MatchActivityPermission(p1, p2);
            case Consts.SecurityPolicyType.Data:
                return this.MatchDataPermission(p1, p2);
        }
        return false;
    }

    GetEffectivePermissionValue(treeRow: Models.ISecurityTreeRow) {
        var row = treeRow;
        var permissionValue = 0;
        while (row != null) {
            var permission = this.FindPermission(row);
            if (permission != null) {
                permissionValue |= permission.permissionValue;
            }
            row = row.parentTreeRow;
        }
        return permissionValue;
    }

    SavePermissions() {
        this.notifyService.startProgress();
        this.securityConfigService.setPolicyPermissions(this.securityPolicyID, this.policyPermissions)
            .then(() => {
                this.notifyService.notifySuccess("Policy Permissions Saved");
                this.$window.location.assign(this.returnUrl);
            },
                (reason: ng.IHttpPromiseCallbackArg<any>) => {
                    this.notifyService.notifyError("Error Saving Policy Permissions: " + reason.statusText);
                })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    Collapse() {
        var collapseTreeRow = (row: Models.ISecurityTreeRow) => {
            row.open = false;
            row.childTreeRows.forEach(childRow => collapseTreeRow(childRow));
        };

        this.treeRows.forEach((row) => collapseTreeRow(row));
        this.CalculateVisibleRows();
    }

}
